import React, { useState } from "react";

// components
import CardPlanTable from "components/Cards/CardPlanTable.js";
import CardPlanForm from "components/Cards/CardPlanForm.js";

export default function Plans() {
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleEditPlan = (plan) => {
    setSelectedPlan(plan);
    setIsFormOpen(true);
  };

  const handleNewPlan = () => {
    setSelectedPlan(null);
    setIsFormOpen(true);
  };

  const handleFormSave = (result) => {
    setIsFormOpen(false);
    setSelectedPlan(null);
    // Trigger refresh of table
    setRefreshTrigger(prev => prev + 1);
  };

  const handleFormCancel = () => {
    setIsFormOpen(false);
    setSelectedPlan(null);
  };

  const handlePlanDeleted = (planId) => {
    // Trigger refresh of table
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <>
      <div className="flex flex-wrap mt-4">
        {/* Main Plan Table */}
        <div className="w-full mb-12 px-4">
          <CardPlanTable
            key={refreshTrigger}
            onEditPlan={handleEditPlan}
            onDeletePlan={handlePlanDeleted}
            onNewPlan={handleNewPlan}
          />
        </div>
      </div>

      {/* Plan Form Modal */}
      <CardPlanForm
        plan={selectedPlan}
        isOpen={isFormOpen}
        onSave={handleFormSave}
        onCancel={handleFormCancel}
      />
    </>
  );
}
